import { webApi } from './webApiClient'

// Setup window.api for compatibility with existing code
declare global {
  interface Window {
    api?: typeof webApi
  }
}

// Set window.api to webApi for fallback when IndexedDB is not available
if (typeof window !== 'undefined') {
  window.api = webApi;
}

export { webApi }